import { createContext } from "react";

const AppContext = createContext({
  selectedPartnerId: {},
  setSelectedPartnerId: (id: number) => {},
});

export default AppContext;
